
import { Component, Vue, Prop } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import draggable from "vuedraggable";
import SearchItem from "./StockSearchItem.vue";
import {
  checkPermissionCompany
} from '@/utils/permission';
import { Type } from '@/types/permissionType';

@Component({
  name: "StockSearch",
  components: {
    draggable,
    SearchItem,
  },
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => {},
  })
  stockData!: any;

  private isToggle = false;
  private checkList: any = [];
  private searchArray: any = [];
  private form: any = {
    orderdate: [],
    category: '',
    name: '',
    model: "",
    serial: "",
    specification: "",
    type: '',
    inout_type: '',
    staff: {},
    customer: '',
    ordernumber: "",
  };
  private showCustomerSearch = false
  private searchKey = "";
  private visiblePopover = false;

  // 公司是否开启新版备件（开启后显示"大类"搜索项，字段为 p_stock_name）
  get isNewSpareParts() {
    const company: any = UserModule.getCompany;
    return !!(company && company.is_new_spare_parts && parseInt(company.is_new_spare_parts) === 1);
  }

  created() {
    this.showCustomerSearch = checkPermissionCompany(UserModule.getCompanyId, Type.CUSTOMER_COMPANY);

    this.searchKey = "lsjl_search" + this.$route.path;
    let index = this.searchKey.lastIndexOf("/");
    if (index > 0) {
      this.searchKey = this.searchKey.substr(0, index);
    }
    if (localStorage.getItem(this.searchKey)) {
      let local: any = localStorage.getItem(this.searchKey);
      let localParse = JSON.parse(local);
      if (this.showCustomerSearch) {
        for (let p = 0; p < localParse.length; p++) {
          if (localParse[p].id === '8') {
            localParse[p].show = true
          }
        }
      } else {
        for (let p = 0; p < localParse.length; p++) {
          if (localParse[p].id === '8') {
            localParse[p].show = false
          }
        }
      }
      // 新备件开启时补充"大类"搜索项（旧缓存中没有则插入到"名称"之前）
      if (this.isNewSpareParts && !localParse.some((item: any) => item.id === '10')) {
        const categoryItem: any = {
          fields: this.form.category,
          name: "大类",
          id: "10",
          checked: true,
          show: true,
        };
        const nameIndex = localParse.findIndex((item: any) => item.id === '2');
        if (nameIndex > -1) {
          localParse.splice(nameIndex, 0, categoryItem);
        } else {
          localParse.push(categoryItem);
        }
      }
      for (let p = 0; p < localParse.length; p++) {
        if (localParse[p].id === '10') {
          localParse[p].show = this.isNewSpareParts;
        }
      }
      for (let p = 0; p < localParse.length; p++) {
        localParse[p].fields = '';
      }
      this.searchArray = localParse;
    } else {
      this.searchArray = [
        {
          fields: this.form.orderdate,
          name: "日期",
          id: "1",
          checked: false,
          show: true,
        },
        {
          fields: this.form.category,
          name: "大类",
          id: "10",
          checked: this.isNewSpareParts,
          show: this.isNewSpareParts,
        },
        {
          fields: this.form.name,
          name: "名称",
          id: "2",
          checked: true,
          show: true,
        },
        {
          fields: this.form.model,
          name: "型号",
          id: "3",
          checked: true,
          show: true,
        },
        {
          fields: this.form.serial,
          name: "编号",
          id: "4",
          checked: false,
          show: true,
        },
        {
          fields: this.form.specification,
          name: "规格",
          id: "5",
          checked: true,
          show: true,
        },
        {
          fields: this.form.type,
          name: "类型",
          id: "6",
          checked: true,
          show: true,
        },
        {
          fields: this.form.staff,
          name: "人员",
          id: "7",
          checked: false,
          show: true,
        },
        {
          fields: this.form.customer,
          name: "客户",
          id: "8",
          checked: this.showCustomerSearch,
          show: true,
        },
        {
          fields: this.form.ordernumber,
          name: "单号",
          id: "9",
          checked: false,
          show: true,
        }
      ];
    }

    if (this.stockData) {
      this.form.staff = {
        id: this.stockData.inout_user_id,
        name: this.stockData.inout_user_name
      };
      this.form.name = this.stockData.stock_name;
      this.form.model = this.stockData.model_name;
      this.form.select = [this.stockData.type, 0];
      this.form.type = this.stockData.type;
      this.form.inout_type = 0;
      this.form.customer = this.stockData.customer_name;
      this.form.category = this.stockData.p_stock_name;
      this.searchArray.map((item:any) => {
        if (item.id === '7') {
          item.fields = this.form.staff
        }
        if (item.id === '8') {
          item.fields = this.form.customer
        }
        if (item.id === '10') {
          item.fields = this.form.category
        }
      })

      let TimeRange: any = [];
      if ( this.form.orderdate && this.form.orderdate.length>0 ) {
        console.log(this.form.orderdate );
        TimeRange = [new Date(this.form.orderdate[0].replace(/-/g, '/') + ' 00:00').getTime().toString().substring(0, 10), new Date(this.form.orderdate[1].replace(/-/g, '/') + ' 23:59').getTime().toString().substring(0, 10)];
      }

      const params = {
        start_time: TimeRange[0] ? TimeRange[0] : '',
        end_time: TimeRange[1] ? TimeRange[1] : '',
        // times: this.form.orderdate ? this.form.orderdate.toString().substring(0, 10) : '',
        p_stock_name: this.form.category,
        stock_name: this.form.name,
        model_name: this.form.model,
        serial_number: this.form.serial,
        specification: this.form.specification,
        type: this.form.type,
        inout_type: this.form.inout_type,
        inout_user_id: this.form.staff.id,
        inout_user_name: this.form.staff.name,
        customer_name: this.form.customer,
        order_num: this.form.ordernumber,
      };
      this.$emit("stockSearch", params);
    }
  }

  private handleSearch() {
    let TimeRange: any = '';
    if ( this.form.orderdate && this.form.orderdate.length>0 ) {
      TimeRange = [new Date(this.form.orderdate[0].replace(/-/g, '/') + ' 00:00').getTime().toString().substring(0, 10), new Date(this.form.orderdate[1].replace(/-/g, '/') + ' 23:59').getTime().toString().substring(0, 10)];
    }
    const params = {
      start_time: TimeRange[0] ? TimeRange[0] : '',
      end_time: TimeRange[1] ? TimeRange[1] : '',
      // times: this.form.orderdate ? this.form.orderdate.toString().substring(0, 10) : '',
      p_stock_name: this.form.category,
      stock_name: this.form.name,
      model_name: this.form.model,
      serial_number: this.form.serial,
      specification: this.form.specification,
      type: this.form.type,
      inout_type: this.form.inout_type,
      inout_user_id: this.form.staff.id,
      inout_user_name: this.form.staff.name,
      customer_name: this.form.customer,
      order_num: this.form.ordernumber,
    };
    this.$emit("stockSearch", params);
  }

  private handleClear() {
    this.form = {
      orderdate: [],
      category: '',
      name: '',
      model: "",
      serial: "",
      specification: "",
      type: '',
      inout_type: '',
      staff: {},
      customer: '',
      ordernumber: "",
    };

    if (this.searchArray) {
      for (let v = 0; v < this.searchArray.length; v++) {
        this.searchArray[v].fields = "";
      }
    }
    this.handleSearch();
  }

  private formReceive(val: any, keyup: any) {
    let parameters: any = {};
    parameters.company_id = UserModule.getCompanyId;
    switch (val.id) {
      case "1":
        this.form.orderdate = val.fields;
        break;
      case "2":
        this.form.name = val.fields;
        break;
      case "10":
        this.form.category = val.fields;
        break;
      case "3":
        this.form.model = val.fields;
        break;
      case "4":
        this.form.serial = val.fields;
        break;
      case "5":
        this.form.specification = val.fields;
        break;
      case "6":
        this.form.type = val.fields[0];
        this.form.inout_type = val.fields[1];
        break;
      case "7":
        this.form.staff = val.fields;
        break;
      case "8":
        this.form.customer = val.fields;
        break;
      case "9":
        this.form.ordernumber = val.fields;
        break;
    }
    if (keyup) {
      this.handleSearch();
    }
  }

  toggleHandle() {
    this.isToggle = !this.isToggle;
  }
  confirmHandle() {
    let setItem: any = [];
    setItem = this.searchArray.filter(
      (t: any) => !this.checkList.some((ele: any) => ele.id === t.id)
    );
    for (let m = 0; m < this.searchArray.length; m++) {
      for (let i = 0; i < setItem.length; i++) {
        if (this.searchArray[m].id === setItem[i].id) {
          this.searchArray[m].checked = false; // 设置取消
        }
      }
    }
    for (let m = 0; m < this.searchArray.length; m++) {
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.searchArray[m].id === this.checkList[i].id) {
          this.searchArray[m].checked = true; // 设置选中
        }
      }
    }
    this.settingLocal();
    this.visiblePopover = false;
  }

  settingLocal() {
    localStorage.setItem(this.searchKey, JSON.stringify(this.searchArray));
  }
}
